import { TableColumnType, TableComponent } from "@tutellus/tutellus-components"
import { TokenAmountSerialized } from "../../../domain/token/Models/TokenAmount"
import { useTranslation } from "react-i18next"
import { useFormatAmounts } from "../../../hooks/useFormatAmounts"
import React from "react"
import { TokenNameCell } from "../../TableCells/TokenNameCell"

export type TokenAmountCollapsibleTableProps = {
  data: TokenAmountSerialized[]
  caption?: React.ReactNode
}

export const TokenAmountCollapsibleTable = ({ data, caption }: TokenAmountCollapsibleTableProps) => {
  const { t } = useTranslation("dashboard")
  const { formatAmount } = useFormatAmounts()

  const columns: TableColumnType<TokenAmountSerialized>[] = [
    {
      key: "tokenID",
      header: t("token"),
      content: ({ tokenID }) => <TokenNameCell size="small" tokenID={tokenID} />,
      sortable: false,
    },
    {
      key: "number",
      header: t("amount"),
      content: ({ number }) => formatAmount(number),
      align: "right",
      sortable: false,
    },
  ]

  return <TableComponent variant="card" caption={caption} columns={columns} data={data} />
}
